import * as SectionController from './SectionController';

export const adminApi = {
  section: SectionController,
};
